export default "__VITE_ASSET__1769ac5b__"